"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TOP_NAV_HEIGHT = exports.SECONDARY_TEXT_COLOR = exports.ELEMENT_PADDING = exports.ELEMENT_DISABLED_COLOR = exports.BG_COLOR_FOCUS = exports.BG_COLOR_HOVER = exports.BG_COLOR_ACTIVE = exports.BG_COLOR = void 0;

var _color = _interopRequireDefault(require("@decisiv/design-tokens/lib/color"));

var _spacing = _interopRequireDefault(require("@decisiv/design-tokens/lib/spacing"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var BG_COLOR = _color.default.base.midnight;
exports.BG_COLOR = BG_COLOR;
var BG_COLOR_ACTIVE = _color.default.base.snowWhite;
exports.BG_COLOR_ACTIVE = BG_COLOR_ACTIVE;
var BG_COLOR_HOVER = _color.default.base.alaskanHusky;
exports.BG_COLOR_HOVER = BG_COLOR_HOVER;
var BG_COLOR_FOCUS = _color.default.opacity.fullMoon50;
exports.BG_COLOR_FOCUS = BG_COLOR_FOCUS;
var ELEMENT_DISABLED_COLOR = _color.default.base.alaskanHusky;
exports.ELEMENT_DISABLED_COLOR = ELEMENT_DISABLED_COLOR;
var ELEMENT_PADDING = _spacing.default.base * 1.2;
exports.ELEMENT_PADDING = ELEMENT_PADDING;
var SECONDARY_TEXT_COLOR = _color.default.base.halfMoon;
exports.SECONDARY_TEXT_COLOR = SECONDARY_TEXT_COLOR;
var TOP_NAV_HEIGHT = _spacing.default.base * 6;
exports.TOP_NAV_HEIGHT = TOP_NAV_HEIGHT;